/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from "react";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Link from "@mui/material/Link";
import { useTheme } from "@emotion/react";

const BaseCard = ({
  title,
  featureRows = [],
  pricing,
  pricingDescription,
  featureRowsTitle,
  callToAction = {},
  freeTrialPlan,
  currentPlan = false,
}) => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        minWidth: 350,
        borderRadius: "1rem",
        padding: "2rem 1rem",
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
      }}
    >
      <CardContent sx={{ height: "75%", display: "flex", flexDirection: "column" }}>
        <MDTypography variant="h3" gutterBottom color="black">
          {title}
        </MDTypography>

        {pricing && (
          <MDTypography variant="h4" mt={2} mb={pricingDescription ? 0 : 4} color="black">
            {pricing}
          </MDTypography>
        )}
        {pricingDescription && (
          <MDTypography variant="caption" mb={4} sx={{ whiteSpace: "pre-line" }}>
            {pricingDescription}
          </MDTypography>
        )}

        {featureRowsTitle && (
          <MDTypography variant="caption" sx={{ whiteSpace: "pre-line" }} mb={1}>
            {featureRowsTitle}
          </MDTypography>
        )}

        {featureRows?.length && (
          <MDBox>
            {featureRows.map((feature) => (
              <MDBox key={feature} sx={{ display: "flex", padding: 0, margin: 0 }}>
                <MDBox>
                  <CheckCircleOutlineIcon
                    style={{ marginRight: "0.5rem", color: theme.palette.trendGreen.main }}
                  />
                </MDBox>
                <MDTypography fontSize="small" sx={{ maxWidth: "200px" }}>
                  {feature}
                </MDTypography>
              </MDBox>
            ))}
          </MDBox>
        )}
      </CardContent>
      {callToAction?.label && (
        <CardActions
          sx={{
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <MDBox
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
            }}
          >
            {title === "Pro" &&
            freeTrialPlan &&
            (!freeTrialPlan?.disabled || freeTrialPlan?.currentPlan) ? (
              <Link
                href={freeTrialPlan?.currentPlan ? null : freeTrialPlan?.callToAction?.href}
                target="_blank"
              >
                <MDButton
                  m={0}
                  variant="gradient"
                  color={freeTrialPlan?.currentPlan ? "secondary" : "primary"}
                  size="small"
                  onClick={freeTrialPlan?.callToAction?.onClick}
                  disabled={freeTrialPlan?.currentPlan}
                  sx={{
                    width: "150px",
                  }}
                >
                  {freeTrialPlan?.callToAction?.label}
                </MDButton>
              </Link>
            ) : null}
            <Link href={currentPlan ? null : callToAction.href} target="_blank">
              <MDButton
                m={0}
                variant="gradient"
                color={currentPlan ? "secondary" : "primary"}
                size="small"
                onClick={callToAction.onClick}
                disabled={currentPlan}
                sx={{
                  width: "150px",
                }}
              >
                {currentPlan ? "Current Plan" : callToAction.label}
              </MDButton>
            </Link>
          </MDBox>
        </CardActions>
      )}
    </Card>
  );
};

export default BaseCard;
